import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Flame, ShieldCheck } from "lucide-react";

export default function AgeGate() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (localStorage.getItem("pe_age_ok") !== "true") setVisible(true);
  }, []);

  const enter = () => {
    localStorage.setItem("pe_age_ok", "true");
    setVisible(false);
  };
  const leave = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[100] flex items-center justify-center p-6 backdrop-blur-md"
          style={{ background: "rgba(0,0,0,0.92)" }} data-testid="age-gate">
          <motion.div initial={{ scale: 0.95, y: 12 }} animate={{ scale: 1, y: 0 }}
            className="w-full max-w-md text-center rounded-3xl p-8"
            style={{ background: "#121212", border: "1px solid #D4AF37" }}>
            <Flame className="text-[#D4AF37] mx-auto mb-3" size={36} />
            <div className="font-heading text-4xl gold-text mb-1">Pleasure Empire</div>
            <div className="overline mb-6">Adults Only · 18+</div>
            <p className="text-sm text-[#A0A0A0] leading-relaxed mb-2">
              This website contains age-restricted material intended for adults only.
            </p>
            <p className="text-sm text-[#A0A0A0] leading-relaxed mb-6">
              By entering, you confirm that you are at least <span className="text-white font-medium">18 years of age</span> (or the age of majority where you live), and that viewing adult content is legal in your location.
            </p>
            <div className="flex flex-col gap-3">
              <button data-testid="age-gate-enter" onClick={enter}
                className="btn-gold rounded-full py-3 flex items-center justify-center gap-2">
                <ShieldCheck size={18} /> I am 18 or older — Enter
              </button>
              <button data-testid="age-gate-leave" onClick={leave}
                className="btn-outline-gold rounded-full py-3">I am under 18 — Leave</button>
            </div>
            <p className="text-[10px] text-[#A0A0A0] mt-6 leading-relaxed">
              We enforce a strict zero-tolerance policy against any content involving minors or non-consenting individuals.
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
